<div class="custom-toolbar">
  <div class="custom-toolbar-subdivision-left custom-toolbar-element">
    <yo-button
      iconClass="fa fa-plus"
      [theme]="ButtonThemeEnum.ADD"
      label="CRÉER"
      (onClick)="openEditConfig(null)"
      tooltip="Créer un élément facturable">
    </yo-button>
    <yo-button
      iconClass="fas fa-edit"
      [theme]="ButtonThemeEnum.DEFAULT"
      label="MODIFICATION DE MASSE"
      [disabled]="!canMassEdit"
      (onClick)="openModificationMasseDialog()"
      tooltip="Modifier les abonnements aux flux de plusieurs configurations (même provider)">
    </yo-button>
  </div>
</div>

<div class="container-table">
  <dx-data-grid
    [dataSource]="gefConnectionList"
    keyExpr="id"
    height="100%"
    width="100%"
    [hoverStateEnabled]="true"
    [allowColumnResizing]="true"
    [rowAlternationEnabled]="false"
    [showRowLines]="true"
    [showBorders]="true"
    (onSelectionChanged)="onSelectionChanged($event)"
    #grid
  >
    <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[20, 50, 100]"
      [showInfo]="true"
      infoText="{2} configuration(s)">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxi-column dataField="id" alignment="center" caption="Actions" cellTemplate="actionsCellTemplate" width="100"
                [allowFiltering]="false">
    </dxi-column>
    <dxi-column dataField="site.libelle" caption="Site" cellTemplate="siteCellTemplate">
    </dxi-column>
    <dxi-column dataField="gefProvider" alignment="left" caption="GEF"
                cellTemplate="gefProviderCellTemplate"></dxi-column>
    <dxi-column dataField="gefFluxList" alignment="left" caption="Abonnement(s) aux Flux"
                cellTemplate="fluxCellTemplate"
                width="400"
    >
    </dxi-column>
    <dxi-column dataField="actif" alignment="center" caption="Actif" [allowFiltering]="false"></dxi-column>

    <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
      <yo-button size="small"
                 [theme]="ButtonThemeEnum.DEFAULT_INNER"
                 (onClick)="openEditConfig(cell.row.data)"
                 [iconClass]="gestionGefSvc.canModify(cell.row.data)? 'fa fa-edit' : 'fas fa-eye'"
                 [tooltip]="gestionGefSvc.canModify(cell.row.data)? 'Modifier la configuration GEF' : 'Voir la configuration GEF'">
      </yo-button>
      <yo-button size="small"
                 [theme]="ButtonThemeEnum.SECONDARY_INNER"
                 (onClick)="openDuplicationDialog(cell.row.data)"
                 iconClass="fa fa-copy"
                 tooltip="Dupliquer la configuration vers d'autres sites">
      </yo-button>
    </div>

    <div *dxTemplate="let cell of 'siteCellTemplate'">
      <yo-site [siteLibelle]="cell.row.data.site.libelle" [siteId]="cell.row.data.site.id"></yo-site>
    </div>

    <div *dxTemplate="let cell of 'gefProviderCellTemplate'">
      <span class="genlabel cursor">{{ cell.row.data.gefProvider.code | uppercase }}</span>
    </div>

    <div *dxTemplate="let cell of 'fluxCellTemplate'">
      <ng-container *ngFor="let flux of cell.row.data.gefFluxList">
        <div class="font-12 mg-l-5 ">
          <span class="genlabel">{{ flux }}</span>
        </div>
      </ng-container>
    </div>


  </dx-data-grid>
</div>

<yo-connections-gef-config-edition-dialog></yo-connections-gef-config-edition-dialog>
<yo-connections-gef-duplication-dialog></yo-connections-gef-duplication-dialog>
<yo-connections-gef-mass-edit-dialog></yo-connections-gef-mass-edit-dialog>
